import {FC} from 'react';
import { StepExecutionAssignableJobFunctionDto } from '../../../dtos/generated/StepExecutionAssignableJobFunctionDto';
import { Box, Typography } from '@mui/material';
import { JobFunctionUserSelect } from '../../../Components/CommonInputs';

export interface ICompleteStepJobFunctionAssignmentFormProps {
    jobFunctionAssignments: StepExecutionAssignableJobFunctionDto[];
    setJobFunctionAssignments: React.Dispatch<React.SetStateAction<StepExecutionAssignableJobFunctionDto[]>>
};

export const CompleteStepJobFunctionAssignmentForm: FC<ICompleteStepJobFunctionAssignmentFormProps> = ({
    jobFunctionAssignments,
    setJobFunctionAssignments
}) => {
    
    if (jobFunctionAssignments.length === 0) {
        return <Typography align='center'>No Job Functions to Assign</Typography>
    }

    return (
        <Box display='flex' flexDirection='column' gap={1}>
            {jobFunctionAssignments.map((jobFunctionToAssign) => (
                <JobFunctionUserSelect
                    key={jobFunctionToAssign.clientJobFunctionId}
                    label={`${jobFunctionToAssign.jobFunctionName} Job Function`}
                    jobFunctionId={jobFunctionToAssign.clientJobFunctionId}
                    selectedUserId={jobFunctionToAssign.assignedUserId ?? ''}
                    handleSelectedUserChange={(selectedUser) => setJobFunctionAssignments((prev) => prev.map((jobFunctionAssignment) => {
                            if (jobFunctionAssignment.clientJobFunctionId === jobFunctionToAssign.clientJobFunctionId) {
                                return {...jobFunctionAssignment, assignedUserId: selectedUser?.userId }
                            }
                            return jobFunctionAssignment;
                        })
                    )}
                />
            ))}
        </Box>
    )
};